import { useRouteLoaderData } from 'react-router';
import type { loader } from '@/root.tsx';

export const useRedesign = () =>
  useRouteLoaderData<typeof loader>('root')?.uiVersion === 'v2';
